import { __assign } from "tslib";
import { renderAndMountComponent } from '@wix/answers-lib';
import * as React from 'react';
import { Tabs } from './tabs';
import { getLegacyBaseDriverFromWrapper } from '../../common/base-driver';
export var createTabsDriverLegacyDriver = function (wrapper) {
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, '.tabs', 'tabs');
    return {
        getTabTexts: function () {
            return baseDriver.findAll('.tab').getText();
        },
        getSelected: function () {
            return baseDriver.find('.selected').getText();
        },
        selectTab: function (idx) {
            baseDriver.findAll(".tab").clickOn(idx);
        }
    };
};
export var createTabs = function (props) {
    var elem = renderAndMountComponent(React.createElement(Tabs, __assign({}, props)));
    return createTabsDriverLegacyDriver(elem);
};
//# sourceMappingURL=tabs.legacy-driver.js.map